import {useZero} from '@/shared/integrations/zero/use-zero'
import {UpdateResourceStatusSchema} from '@cypro/engine/mutators/util'
import {useCallback} from 'react'

export function useUpdateSectionStatus() {
  const zero = useZero()

  return useCallback(
    (payload: UpdateResourceStatusSchema) =>
      zero.attemptMutation(
        zero.mutators.sections.updateStatus({sectionIds: [payload.id], status: payload.status}),
        async mutation => await mutation.server
      ),
    [zero]
  )
}
